<template>
  <div>
    <Button :icon="processing ? 'pi pi-spin pi-spinner' : 'pi pi-ellipsis-v'"
            class="p-button-secondary p-button-raised action-button"
            :disabled="disabled || processing || !menuItems.length"
            @click="toggle"/>

    <Menu ref="menu"
          :model="menuItems"
          :popup="true"
          appendTo="body"/>
  </div>
</template>

<script>
import Menu from 'primevue/menu'

const STATE_DRAFT = 1
const STATE_OPEN = 2
const STATE_PAID = 3
const STATE_PAYMENT_FAILED = 4
const STATE_CANCELED = 5
const STATE_VOID = 6
const STATE_PAID_PARTIALLY = 7
const STATE_OVERPAID = 8

export default {
  name: 'BillingInvoiceActionsButton',
  components: {
    Menu,
  },
  emits: ['action'],
  props: {
    invoice: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    processing: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggle(event) {
      this.$refs.menu.toggle(event)
    },
    emitAction(action) {
      this.$emit('action', {
        action,
        invoice: this.invoice,
      })
    },
  },
  computed: {
    state() {
      return Number(this.invoice?.state || 0)
    },
    canDelete() {
      const invoice = this.invoice

      if (!invoice?.id) return false

      return [1, 5].includes(+invoice.state)
          && !invoice.issued_at
          // && !invoice.sent_at
          && !invoice.export_id
          && !invoice.export_number
          && !invoice.stripe_invoice_id
          && !invoice.stripe_payment_intent_id
          && Number(invoice.paid_amount || 0) <= 0
    },
    canReturnToDraft() {
      return (
          this.state === STATE_OPEN
          // && !this.invoice?.sent_at
          && Number(this.invoice?.paid_amount || 0) === 0
          && !this.invoice?.export_id
          && !this.invoice?.export_number
      )
    },

    menuItems() {
      const items = []

      if (!this.invoice?.id) {
        return items
      }

      if (this.state === STATE_DRAFT) {
        items.push({
          label: this.$t('billing.invoices.issueAction'),
          icon: 'ti-check',
          command: () => this.emitAction('issue'),
        })

        items.push({
          label: this.$t('billing.invoices.cancelDraftAction'),
          icon: 'ti-close',
          command: () => this.emitAction('cancel'),
        })
      }

      if (this.state === STATE_OPEN) {
        items.push({
          label: this.$t('billing.invoices.confirmPaymentAction'),
          icon: 'ti-check',
          command: () => this.emitAction('mark_paid'),
        })

        if (this.canReturnToDraft) {
          items.push({
            label: this.$t('billing.invoices.returnToDraftAction'),
            icon: 'ti-back-left',
            command: () => this.emitAction('return_to_draft'),
          })
        }

        items.push({
          separator: true,
        })

        items.push({
          label: this.$t('billing.invoices.voidAction'),
          icon: 'ti-na',
          command: () => this.emitAction('void'),
        })
      }

      if (this.state === STATE_PAYMENT_FAILED) {
        items.push({
          label: this.$t('billing.invoices.confirmPaymentAction'),
          icon: 'ti-check',
          command: () => this.emitAction('mark_paid'),
        })

        items.push({
          separator: true,
        })

        items.push({
          label: this.$t('billing.invoices.voidAction'),
          icon: 'ti-na',
          command: () => this.emitAction('void'),
        })
      }

      if (this.state === STATE_PAID_PARTIALLY) {
        items.push({
          label: this.$t('billing.invoices.confirmFullPaymentAction'),
          icon: 'ti-check',
          command: () => this.emitAction('mark_paid'),
        })

        items.push({
          separator: true,
        })

        items.push({
          label: this.$t('billing.invoices.voidAction'),
          icon: 'ti-na',
          command: () => this.emitAction('void'),
        })
      }

      if (this.state === STATE_PAID) {
        items.push({
          label: this.$t('billing.invoices.voidAction'),
          icon: 'ti-na',
          command: () => this.emitAction('void'),
        })
      }

      if (this.state === STATE_OVERPAID) {
        items.push({
          label: this.$t('billing.invoices.voidAction'),
          icon: 'ti-na',
          command: () => this.emitAction('void'),
        })
      }

      if ([STATE_CANCELED, STATE_VOID].includes(this.state)) {
        items.push({
          label: this.state === STATE_CANCELED
              ? this.$t('billing.invoices.restoreDraftAction')
              : this.$t('billing.invoices.restoreAction'),
          icon: 'ti-back-left',
          command: () => this.emitAction('restore'),
        })
      }

      if (this.canDelete) {
        if (items.length) {
          items.push({
            separator: true,
          })
        }

        items.push({
          label: this.$t('Delete'),
          icon: 'ti-trash',
          command: () => this.emitAction('delete'),
        })
      }

      return items
    },
  },
}
</script>

<!--<style scoped lang="scss">-->
<!--.action-button {-->
<!--  margin: 0 3px;-->
<!--}-->
<!--</style>-->